import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-system-updates-list',
  templateUrl: './system-updates-list.component.html',
  styleUrls: ['./system-updates-list.component.scss']
})
export class SystemUpdatesListComponent implements OnInit {
  updates: any[] = [];
  role: string | null = null;
  loading = false;
  showForm = false;
  selectedUpdate: any = null;

  constructor(
    private supportService: SupportService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.role = localStorage.getItem('role');
    this.loadUpdates();
  }

  loadUpdates(): void {
    this.loading = true;
    this.spinner.show('su-spinner');
    this.supportService.getSystemUpdates().subscribe({
      next: (res: any) => {
        this.updates = res.response?.data || [];
        this.loading = false;
        this.spinner.hide('su-spinner');
      },
      error: (err: any) => {
        this.loading = false;
        this.spinner.hide('su-spinner');
        this.toastr.error(err.error?.response?.message || 'Failed to load system updates');
      }
    });
  }

  openCreateForm(): void {
    this.selectedUpdate = null;
    this.showForm = true;
  }

  openEditForm(update: any): void {
    this.selectedUpdate = update;
    this.showForm = true;
  }

  onSaved(): void {
    this.showForm = false;
    this.selectedUpdate = null;
    this.loadUpdates();
  }

  onCancelled(): void {
    this.showForm = false;
    this.selectedUpdate = null;
  }

  deleteUpdate(id: string): void {
    Swal.fire({
      title: 'Delete this update?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete it'
    }).then(result => {
      if (result.isConfirmed) {
        this.spinner.show('su-spinner');
        this.supportService.deleteSystemUpdate(id).subscribe({
          next: () => {
            this.spinner.hide('su-spinner');
            this.toastr.success('Update deleted');
            this.loadUpdates();
          },
          error: (err: any) => {
            this.spinner.hide('su-spinner');
            this.toastr.error(err.error?.response?.message || 'Failed to delete update');
          }
        });
      }
    });
  }
}
